import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './AuthPage.css';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const captchaWidgetId = useRef(null);

  // Carga el script de Google reCAPTCHA una sola vez y renderiza el widget
  // a mano (sin libreria nueva, es solo un script + una funcion global).
  useEffect(() => {
    if (!RECAPTCHA_SITE_KEY) return;
    const renderWidget = () => {
      if (window.grecaptcha && window.grecaptcha.render) {
        captchaWidgetId.current = window.grecaptcha.render('recaptcha-container', {
          sitekey: RECAPTCHA_SITE_KEY,
        });
      }
    };
    if (window.grecaptcha && window.grecaptcha.render) {
      renderWidget();
      return;
    }
    window.onRecaptchaLoad = renderWidget;
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    const captchaToken = RECAPTCHA_SITE_KEY && window.grecaptcha
      ? window.grecaptcha.getResponse(captchaWidgetId.current)
      : '';
    if (RECAPTCHA_SITE_KEY && !captchaToken) {
      setError('Confirma que no eres un robot antes de registrarte.');
      return;
    }

    setSubmitting(true);
    try {
      await axios.post('/auth/register', { email, password, captcha_token: captchaToken });
      setMessage('¡Registro completado! Te hemos enviado un correo para confirmar tu cuenta. Ya puedes iniciar sesión.');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Error en el registro. Por favor, inténtalo de nuevo.');
      }
    } finally {
      setSubmitting(false);
      if (RECAPTCHA_SITE_KEY && window.grecaptcha && captchaWidgetId.current !== null) {
        window.grecaptcha.reset(captchaWidgetId.current);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Registrarse</h1>
        <p className="auth-subtitle">Crea tu cuenta de Almaley</p>

        {error && <div className="alert alert-error">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}

        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label>Correo electrónico</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="tu@email.com"
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Mínimo 6 caracteres"
            />
          </div>
          {RECAPTCHA_SITE_KEY && (
            <div id="recaptcha-container" style={{ margin: '12px 0' }}></div>
          )}
          <button
            type="submit"
            className="btn btn-primary full-width"
            disabled={submitting}
          >
            {submitting ? 'Creando cuenta…' : 'Registrarse'}
          </button>
        </form>

        <p className="auth-footer">
          ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
